import { render, staticRenderFns } from "./AddressConfirmModal.vue?vue&type=template&id=b8398468&scoped=true&"
import script from "./AddressConfirmModal.vue?vue&type=script&lang=js&"
export * from "./AddressConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8398468",
  null
  
)

export default component.exports